import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { onboardingCopy } from './translations';
import './InvitationDialog.scss';

export default function InvitationDialog({ onStart, onSkip }) {
  const { i18n } = useTranslation('brand', { useSuspense: false });
  const copy = onboardingCopy(i18n.resolvedLanguage || i18n.language || 'en');
  // Keep the button hit areas still from the first frame. Ant's default zoom
  // can move them between pointer-down and pointer-up after language selection.
  return <Modal open centered title={copy.invitationTitle} footer={null} closable={false}
    maskClosable={false} keyboard={false} transitionName="" width="100%" className="onboarding-invitation-modal"
    wrapClassName="onboarding-invitation-wrap">
    <p>{copy.invitationBody}</p>
    <div className="onboarding-invitation-actions">
      <button type="button" className="onboarding-invitation-start" onClick={onStart}>{copy.start}</button>
      <button type="button" className="onboarding-invitation-skip" onClick={onSkip}>{copy.skip}</button>
    </div>
  </Modal>;
}
